<template>
  <div class="product-tabs-container">
    <ekitabu-tabs
      v-model="activeTab"
      :tabs="tabs"
      color="primary"
      bar-class="product-tabs"
      tab-class="text-caption font-weight-bold"
      content-class="mt-4 tab-content-wrapper"
      :centered="$vuetify.breakpoint.smAndDown"
    >
      <!-- Book Details Tab -->
      <ekitabu-tab-item>
        <book-details
          :book="book"
          no-expansion
        />
      </ekitabu-tab-item>

      <!-- Description Tab -->
      <ekitabu-tab-item>
        <div
          class="pa-4 product-description"
          v-html="decodeHtml(book.description)"
        />
      </ekitabu-tab-item>

      <!-- Terms of Service Tab -->
      <ekitabu-tab-item>
        <div class="pa-4">
          <p class="text-body-2">
            {{ $t('bookInfo.termsOfServiceContent') }}
          </p>
          <a
            :href="termsOfServiceUrl"
            target="_blank"
            class="primary--text text-caption font-weight-bold"
          >
            {{ $t('footer.termsOfService') }}
          </a>
        </div>
      </ekitabu-tab-item>

      <!-- Delivery and Returns Tab -->
      <ekitabu-tab-item>
        <div class="pa-4">
          <p class="text-body-2">
            {{ $t('bookInfo.deliveryAndReturnsContent') }}
          </p>
        </div>
      </ekitabu-tab-item>
    </ekitabu-tabs>
  </div>
</template>

<script>
import BookDetails from "@/components/BookDetails.vue";
import { decodeHtml } from "@/helpers/generalFunctions";
import { TERMS_OF_SERVICE_URL } from "@/utils/Const";

export default {
  name: "ProductTabs",
  components: {
    BookDetails,
  },
  props: {
    book: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    tabs() {
      return [
        { title: this.$t("bookInfo.bookDetails") },
        { title: this.$t("bookInfo.description") },
        { title: this.$t("bookInfo.termsOfService") },
        { title: this.$t("bookInfo.deliveryAndReturns") },
      ];
    },
    termsOfServiceUrl() {
      return TERMS_OF_SERVICE_URL;
    },
  },
  methods: {
    decodeHtml(html) {
      return decodeHtml(html);
    },
  },
};
</script>

<style scoped lang="scss">
.product-tabs-container {
  width: 100%;
  background-color: var(--v-background-base);
}

::v-deep .product-tabs {
  border-bottom: 1px solid var(--v-lightAccent-base);
}

.product-description {
  font-size: 14px;
  line-height: 1.8;
  color: var(--v-primaryText-base);
  max-width: 800px;
}

::v-deep .v-tabs-bar {
  background-color: transparent !important;
}

::v-deep .v-tab {
  text-transform: none !important;
  letter-spacing: normal !important;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: var(--v-lightestAccent-base);
  }
}

::v-deep .v-tab--active {
  color: var(--v-primary-base) !important;
  background-color: transparent !important;
}

::v-deep .tab-content-wrapper {
  min-height: 200px;
  animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
